export const extractPropertyList = <T>(items: any[], property: string): T[] => {
  let result: T[] = [];

  items.forEach((item) => {
    result.push(item[property]);
  });

  return result;
};
